// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__eJ7Zf"};